export default "__VITE_ASSET__485a6dec__"